import React, { useState, useEffect } from "react";
import Tabs from "../components/common/Tabs";
import { SingleProductUpload, ProductBulkUpload } from "../components/Product";
import { useParams } from "react-router-dom";

const Products = () => {
  const [activeTab, setActiveTab] = useState("2");
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      setActiveTab("1");
    }
  }, [id]);

  const items = [
    {
      key: "1",
      label: "Single Product Upload",
      children: <SingleProductUpload />,
    },
    {
      key: "2",
      label: "Bulk Product Upload",
      children: <ProductBulkUpload />,
    },
  ];

  return (
    <>
      <Tabs
        items={items}
        size="large"
        activeKey={activeTab}
        onChange={(key) => setActiveTab(key)}
      />
    </>
  );
};

export default Products;
